export function complementOptionMaximum(group: any, option: any): number {
  const raw = option?.quantidadeMaxima;
  const maximum = raw === undefined ? Infinity : Number(raw);
  if (maximum !== Infinity && (!Number.isInteger(maximum) || maximum < 0)) return 0;
  return Math.min(group?.permitirRepetir === false ? 1 : Infinity, maximum);
}

export function complementSelectionValid(group: any, selections: any[]): boolean {
  if (!Array.isArray(selections)) return false;
  const totals = new Map<any, number>();
  for (const selection of selections) {
    const option = (group?.itens || []).find((item: any) => selection.optionId
      ? item.optionId === selection.optionId : item.name === selection.name);
    const count = Number(selection.quantidade);
    if (!option || !Number.isInteger(count) || count <= 0) return false;
    const total = (totals.get(option) || 0) + count;
    if (total > complementOptionMaximum(group, option)) return false;
    totals.set(option, total);
  }
  const maximum = Number(group?.sizeMax);
  return !(maximum > 0) || Array.from(totals.values()).reduce((sum, value) => sum + value, 0) <= maximum;
}
